import QRCodeGenerator from "./QRCodeGenerator"
import './App.css';

function App() {
  return (
    <div className="App">
      <QRCodeGenerator websiteUrl="https://pusalasrivardhan5h.wixsite.com/my-site-1" />

    </div>
  );
}

export default App;
